import { render, staticRenderFns } from "./Oracao.vue?vue&type=template&id=2ce487e8&scoped=true"
import script from "./Oracao.vue?vue&type=script&lang=js"
export * from "./Oracao.vue?vue&type=script&lang=js"
import style0 from "./Oracao.vue?vue&type=style&index=0&id=2ce487e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce487e8",
  null
  
)

export default component.exports